export default function slideToLoop() {
  let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  let runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let internal = arguments.length > 3 ? arguments[3] : undefined;
  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}